/**
 * Caravan type options for the regno & mileage step.
 * Matkailuauto (Travel truck) has mileage; Matkailuvaunu (Travel box) and Talovaunu (Rolling home) do not.
 */
export const CARAVAN_TYPE_MOTORHOME = "Matkailuauto";
export const CARAVAN_TYPE_CARAVAN = "Matkailuvaunu";
export const CARAVAN_TYPE_STORAGE_TRAILER = "Talovaunu";

export type CaravanType =
  | typeof CARAVAN_TYPE_MOTORHOME
  | typeof CARAVAN_TYPE_CARAVAN
  | typeof CARAVAN_TYPE_STORAGE_TRAILER;

export const CARAVAN_TYPES: CaravanType[] = [
  CARAVAN_TYPE_MOTORHOME,
  CARAVAN_TYPE_CARAVAN,
  CARAVAN_TYPE_STORAGE_TRAILER
];

export const CARAVAN_TYPE_DEFAULT: CaravanType = CARAVAN_TYPE_MOTORHOME;

/**
 * Nettix API caravan type IDs (from rest/caravan/options/vehicleType).
 * Used to ensure vertical import uses correct IDs for makes/models API.
 */
export const CARAVAN_TYPE_NETTIX_IDS: Record<CaravanType, number> = {
  [CARAVAN_TYPE_MOTORHOME]: 14,
  [CARAVAN_TYPE_CARAVAN]: 13,
  [CARAVAN_TYPE_STORAGE_TRAILER]: 15
};

/**
 * Reverse mapping from Nettix API ID to CaravanType.
 * Used to resolve caravanType from backend vehicleTypeId/bodyTypeId.
 */
export const NETTIX_ID_TO_CARAVAN_TYPE: Record<number, CaravanType> = {
  14: CARAVAN_TYPE_MOTORHOME,
  13: CARAVAN_TYPE_CARAVAN,
  15: CARAVAN_TYPE_STORAGE_TRAILER
};

export const hasMileage = (caravanType: CaravanType): boolean =>
  caravanType === CARAVAN_TYPE_MOTORHOME;

/**
 * Maps Finnish caravan type names to their localization keys
 */
export const getCaravanTypeLocalizationKey = (
  caravanType: CaravanType
): string => {
  switch (caravanType) {
    case CARAVAN_TYPE_MOTORHOME:
      return "consumer.wizard.caravan.stepRegnoMileage.caravanTypeMotorhome";
    case CARAVAN_TYPE_CARAVAN:
      return "consumer.wizard.caravan.stepRegnoMileage.caravanTypeCaravan";
    case CARAVAN_TYPE_STORAGE_TRAILER:
      return "consumer.wizard.caravan.stepRegnoMileage.caravanTypeStorageTrailer";
    default:
      return "consumer.wizard.caravan.stepRegnoMileage.caravanTypeMotorhome";
  }
};
